import { useState, useEffect } from 'react';
import { Audience } from 'modules/audiences';
import { AudienceStatsFilterv1 } from 'modules/insights';
import { audiencesApi } from 'api/instances';
import moment from 'moment';
import { dateOptions } from 'utils/dateFormatting';

export const useAudienceAnalyticsFilters = () => {
    const [audiences, setAudiences] = useState<Audience[]>([]);
    const [toFetch, setToFetch] = useState(true);
    const [reportFilter, setReportFilter] = useState<Partial<AudienceStatsFilterv1>>({
        startDate: moment().startOf("month").subtract(5, "month").format(dateOptions.basicWithHours),
        endDate: moment().endOf("day").endOf("month").format(dateOptions.basicWithHours),
        audiences: [],
    });

    useEffect(() => {
        if (toFetch) {
            audiencesApi.getAllAudiencesForAuthors()
                .then(audiences => {
                    setAudiences(audiences.filter((audience: Audience) => audience.enabled));
                    setToFetch(false);
                });
        }
    }, [toFetch]);

    const onChangeFilters = (filters: Partial<AudienceStatsFilterv1>) => {
        const updatedFilters = { ...reportFilter, ...filters };
        setReportFilter(updatedFilters);
        setToFetch(true);
    };

    return {
        audiences,
        reportFilter,
        onChangeFilters,
        toFetch
    };
};